import { render, staticRenderFns } from "./App.vue?vue&type=template&id=32a7afea"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=32a7afea&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6554cb098e537a9b8e01f1854c0c52c1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports